"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChartSummary = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _chart = require("../chart");

var _helpers = require("./helpers");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _getStyleVarValue = require("../../helpers/getStyleVarValue");

var _loadStyles = _interopRequireDefault(require("load-styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

(0, _loadStyles.default)(".c8843cb88{width:6.875rem;height:2.3125rem}");
var styles = {
  root: 'c8843cb88'
};

var ChartSummary = function ChartSummary(props) {
  var dataSet = props.dataSet,
      classes = props.classes,
      view = props.view;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  var colors = (0, _react.useMemo)(function () {
    return {
      up: (0, _getStyleVarValue.getStyleVarValue)('--color-flomni-green-70'),
      down: (0, _getStyleVarValue.getStyleVarValue)('--color-flomni-rose-70')
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: cn.root
  }, /*#__PURE__*/_react.default.createElement(_chart.Chart, {
    data: {
      labels: new Array(dataSet.length),
      datasets: [{
        borderColor: colors[view],
        data: dataSet,
        fill: false
      }]
    },
    options: _helpers.options
  }));
};

exports.ChartSummary = ChartSummary;
var view = ['up', 'down'];
ChartSummary.modes = {
  view: view
};
ChartSummary.propTypes = {
  /* component logic props */
  dataSet: (0, _propTypes.arrayOf)(_propTypes.number).isRequired,

  /* styling modificators */
  view: (0, _propTypes.oneOf)(view),

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
ChartSummary.defaultProps = {
  view: 'up',
  classes: {}
};